import React from 'react';

const IsometricIllustration = () => {
  return (
    <div className="relative w-full max-w-md h-96 animate-float">
      {/* Floating 3D cube structure with gradients */}
      <svg viewBox="0 0 400 400" className="w-full h-full">
        <defs>
          <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#0066FF', stopOpacity: 0.8 }} />
            <stop offset="100%" style={{ stopColor: '#7B61FF', stopOpacity: 0.8 }} />
          </linearGradient>
          <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#7B61FF', stopOpacity: 0.7 }} />
            <stop offset="100%" style={{ stopColor: '#FF4D8D', stopOpacity: 0.7 }} />
          </linearGradient>
          <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#00D4FF', stopOpacity: 0.6 }} />
            <stop offset="100%" style={{ stopColor: '#0066FF', stopOpacity: 0.6 }} />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        {/* Main cube - center */}
        <g className="animate-pulse" style={{ animationDuration: '3s' }}>
          {/* Top face */}
          <path d="M200 120 L280 160 L200 200 L120 160 Z" fill="url(#grad1)" filter="url(#glow)" />
          {/* Right face */}
          <path d="M200 200 L280 160 L280 240 L200 280 Z" fill="url(#grad2)" opacity="0.8" />
          {/* Left face */}
          <path d="M200 200 L120 160 L120 240 L200 280 Z" fill="url(#grad3)" opacity="0.7" />
        </g>
        
        {/* Small cube - top right */}
        <g className="animate-pulse" style={{ animationDuration: '2.5s', animationDelay: '0.5s' }}>
          <path d="M300 80 L340 100 L300 120 L260 100 Z" fill="url(#grad2)" filter="url(#glow)" />
          <path d="M300 120 L340 100 L340 140 L300 160 Z" fill="url(#grad1)" opacity="0.8" />
          <path d="M300 120 L260 100 L260 140 L300 160 Z" fill="url(#grad3)" opacity="0.7" />
        </g>
        
        {/* Small cube - bottom left */}
        <g className="animate-pulse" style={{ animationDuration: '2.8s', animationDelay: '0.3s' }}>
          <path d="M100 260 L140 280 L100 300 L60 280 Z" fill="url(#grad3)" filter="url(#glow)" />
          <path d="M100 300 L140 280 L140 320 L100 340 Z" fill="url(#grad2)" opacity="0.8" />
          <path d="M100 300 L60 280 L60 320 L100 340 Z" fill="url(#grad1)" opacity="0.7" />
        </g>
        
        {/* Floating code brackets */}
        <text x="150" y="100" fill="url(#grad1)" fontSize="40" opacity="0.5" className="animate-pulse" style={{ animationDuration: '2s' }}>&lt;/&gt;</text>
        <text x="280" y="250" fill="url(#grad2)" fontSize="32" opacity="0.4" className="animate-pulse" style={{ animationDuration: '2.2s', animationDelay: '0.5s' }}>&#123;&#125;</text>
        
        {/* Connecting lines */}
        <line x1="200" y1="120" x2="300" y2="80" stroke="url(#grad1)" strokeWidth="2" opacity="0.3" strokeDasharray="5,5" className="animate-pulse" />
        <line x1="200" y1="280" x2="100" y2="260" stroke="url(#grad3)" strokeWidth="2" opacity="0.3" strokeDasharray="5,5" className="animate-pulse" style={{ animationDelay: '0.5s' }} />
      </svg>
    </div>
  );
};

export default IsometricIllustration;